import Lottie from "lottie-react";
import animation from "../../Animations/wish-animation.json";
import { useLanguage } from "../../context/LanguageContext";
import BtnSecondaryM from "../Buttons/BtnSecondaryM";
import PropTypes from "prop-types";

const ActionCard = ({ openPopup }) => {
  const { copy } = useLanguage();

  return (
    <div
      className="h-55 card-base cursor-pointer flex flex-col justify-center items-center bg-white card-base-border"
      onClick={openPopup}
    >
      <div className="w-full h-[120px] overflow-hidden relative">
        <Lottie
          animationData={animation}
          loop={true} // Set loop to false so it plays only once
          autoplay={true} // Disable autoplay initially
          className="object-cover w-full h-[105%]"
        />
      </div>
      <BtnSecondaryM buttonCTA={copy.card_wishlist.button} />
    </div>
  );
};

ActionCard.propTypes = {
  openPopup: PropTypes.func.isRequired,
};

export default ActionCard;
